module Shared.Admin.ManageNews.Edit
open Shared
open System
open Illy.SafeStack

type DTO = 
    {
        Headline: string option
        StartShowing: DateTime option
        StopShowing: DateTime option
        Content: string option
        Author: string option
    }

type ValidatedDTO = 
    {
        Headline: string
        StartShowing: DateTime
        StopShowing: DateTime option
        Content: string
        Author: string option
    }

module ValidatedDTO = 
    let ofDTO (dto: DTO) =
        let (>?) v label = v |> Option.defaultWith (fun () -> failwithf "Could not get value for %s." label) 
        {
            Headline = dto.Headline >? "Headline"
            StartShowing = dto.StartShowing >? "StartShowing"
            StopShowing = dto.StopShowing
            Content = dto.Content >? "Content"
            Author = dto.Author
        }

    let toDTO (d: ValidatedDTO): DTO = 
        {
            Headline = Some d.Headline
            StartShowing = Some d.StartShowing
            StopShowing = d.StopShowing
            Content = Some d.Content
            Author = d.Author
        }

module Validations = 
    open Illy.SafeStack.Validation
    open Illy.SafeStack.ROP
    open Illy.SafeStack.CompositionalValidation
    open Illy.SafeStack.SharedValidations

    type StartShowingValidations = 
        | DateValidations of DateValidations 
        | CannotBeAfterTheStopDate
        | MustBeAfterJan2013

    module StartShowingValidations =
        let toString = 
            function 
            | DateValidations v -> v.toString()
            | CannotBeAfterTheStopDate -> "Cannot be after the Stop date."
            | MustBeAfterJan2013 -> "Must be after 1st of January 2013."

    type NewsArticleValidations =
        | HeadlineValidations of StringValidations
        | StartShowingValidations of StartShowingValidations
        | ContentValidations of StringValidations
        | AuthorValidations of StringValidations

    module NewsArticleValidations = 
        let toString = 
            function 
            | HeadlineValidations x -> x.toString()
            | StartShowingValidations x -> StartShowingValidations.toString x
            | ContentValidations x -> x.toString()
            | AuthorValidations x -> x.toString()
    
    let validateStartShowing stopShowingDate startShowingDate = 
        validate {
            return! (validateDate true true >-> StartShowingValidations.DateValidations)startShowingDate

            return! !!(error StartShowingValidations.CannotBeAfterTheStopDate)
                >>= passIfNone startShowingDate
                >>= passIfNone stopShowingDate
                >>= conditional pass (fun ((_, start), endD) -> endD >= start)
                |> mapResult (fst >> fst)

            return! !!(error StartShowingValidations.MustBeAfterJan2013)
                >>= passIfNone startShowingDate
                >>= conditional pass (fun (_, start) -> start >= new DateTime(2013, 1, 1))
                |> firstResult
        }

    let validateDTO (dto: DTO) =
        validate {
            return! (validateString 100 true >-> NewsArticleValidations.HeadlineValidations) dto.Headline
            return! (validateStartShowing dto.StopShowing >-> NewsArticleValidations.StartShowingValidations) dto.StartShowing
            return! (validateString 4000 true >-> NewsArticleValidations.ContentValidations) dto.Content
            return! (validateString 100 false >-> NewsArticleValidations.AuthorValidations) dto.Author
        }

type FailureReason = 
    | FailedValidations of Validation.ValidationResult<Validations.NewsArticleValidations, Validation.NoWarning>
    | NothingToDo
    | ItemWasDeleted 
